import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { embeddedEntryPoint as main } from '@atlassian/jira-spa-apps-help-center-settings-widget-configuration/embeddedEntryPoint.tsx';

export const HelpCenterSettingsEmbeddedWidgetsAppEntryPoint = createPageEntryPoint({
	main,
	topNavigationMenuId: MENU_ID.HELP_CENTER_SETTINGS,
});
